module.exports = __webpack_public_path__ + "media/images/ohap_Plus_White-a504751077c5cedc127ee6b91c848b7d.png";